import { isNil, cloneDeep } from "lodash";

import store from 'stores';
import { resourcesActions } from "stores/slice/resources";
import { pageContextActions, initialState } from "stores/slice/pageContext";
import { adminPageContextActions } from "stores/slice/adminPageContext";
import { deviceModelActions } from "stores/slice/deviceModel";

//API
import AuthService from "services/Auth.service";
import guiService from "services/Auth.gui.service";
import orgService from "services/Auth.Organization.service";
import deviceModelService from "services/Auth.DeviceModel.service";

import { userType, userPrivilege } from "const/nuclias/user";
import { deviceType } from "const/nuclias/device";

// page service
import {
  expandSiteAndTag,
  initSelectedTagSite,
  initOrgTreeMap,
  expandDevice
} from './utils';

export const initResources = async () => {
  try {
    const response = await AuthService.getAuthResources();

    if (response.error) {
      throw response.error;
    }

    store.dispatch(resourcesActions.set(response.params));

  } catch (error) {
    console.error(`initResources: ${error}`);
  }
}

const getOrgBootstrapApi = (orgId) => {
  return new Promise(async (Resolve, Reject) => {
    try {
      const res = await orgService.getOrgBootstrap(orgId);
      Resolve(res.data);
    } catch (error) {
      console.error(`getOrgBootstrapApi: ${error}`);
      Reject();
    }
  });
};

const initOrg = async (orgChildren) => {
  const user = store.getState().user;
  const indexUserType = user.user.type;
  const resultObj = Object.assign({}, initialState);
  switch (indexUserType) {
    case userType.cloudAdmin:
      // nothing
      break;
    case userType.sp:
      resultObj.sp = orgChildren;
      break;
    case userType.si:
      resultObj.si = orgChildren;
      if (!isNil(sessionStorage.mspSelectedOrg)) {
        const access_token = user.token.access_token;
        if (access_token === sessionStorage.access_token) {
          const data = await getOrgBootstrapApi(sessionStorage.mspSelectedOrg);
          resultObj.selectedOrg = data;
        } else {
          sessionStorage.removeItem('mspSelectedOrg');
          sessionStorage.removeItem('token');
        }
      }
      break;
    case userType.org:
      resultObj.selectedOrg = orgChildren;
      break;
    case userType.siteTag:
      const rootTag = orgChildren.storeTags[0];
      resultObj.selectedOrg = orgChildren;// selectedStoreTag gen after expandSiteAndTag
      resultObj.selectedOrg.rootTag = rootTag; // for tag user only
      break;
    case userType.site:
      resultObj.selectedOrg = orgChildren; //selectedStore = null; // gen after expandSiteAndTag
      break;
    default:
      resultObj.selectedOrg = orgChildren;
  }
  return resultObj;
};

const initAdminOrg = (response) => {
  // const user = store.getState().user.user
  const resultObj = {}; //Object.assign({}, adminPageContextInitialState);
  resultObj.orgTree = response.orgChildren?.children;
  resultObj.spList = response.spList;
  resultObj.siList = response.siList;
  return resultObj;
};

export const initDeviceModel = async () => {
  const response = await deviceModelService.getAllDeviceModel();
  const models = response.data.sort((a, b) => a.name.localeCompare(b.name));
  const resultObj = {
    ap: {},
    switch: {},
    gateway: {},
  };
  const resultList = cloneDeep(resultObj);

  const getDeviceModelInfo = async (model) => {
    let featureList = null;
    if (model.name !== 'DBS-2000') { // dbs unused?
      const modelName = model.name !== 'DBG-2000(B1)' ? model.name : 'DBG-X1000'; // b1 = x1000
      featureList = await deviceModelService.getDeviceModelFeatureList(modelName);
      if (featureList?.data && Object.keys(featureList.data).length) {
        featureList = { ...featureList.data[modelName], ...featureList.data[modelName].CP };
        delete featureList.CP;
      }
    }
    const targetType = model.deviceType.toLowerCase();
    resultObj[targetType][model.name] = model;
    resultObj[targetType][model.name].feature = featureList;

    if (targetType === deviceType.switch.toLowerCase()) {
      const series = model.seriesModels || model.childrenModel;
      for (const child of series) {
        resultList[targetType][child.name] = child.name;
      }
    } else {
      resultList[targetType][model.name] = model.name;
    }
  }
  
  const getDeviceModelInfoFns = [];
  for (const model of models) {
    getDeviceModelInfoFns.push(getDeviceModelInfo(model));
  }
  await Promise.all(getDeviceModelInfoFns);
  const result = {
    deviceModelSeries: resultObj,
    deviceModelList: resultList
  };
  store.dispatch(deviceModelActions.setAll(result));
};

export const initPageContext = async () => {
  const user = store.getState().user.user;
  const response = await guiService.getBootstrap();
  if (user.type === userType.cloudAdmin) {
    let orgObj = await initAdminOrg(response);
    // more...
    store.dispatch(adminPageContextActions.setAll(orgObj));
  } else {
    let orgObj = await initOrg(response.orgChildren);
    orgObj = await expandSiteAndTag(orgObj);
    orgObj = await initSelectedTagSite(orgObj);
    orgObj = await initOrgTreeMap(orgObj);
    orgObj = await expandDevice(orgObj);

    store.dispatch(pageContextActions.setAll(orgObj));
  }
};

export const setIndexOrg = async (orgId) => {
  return new Promise(async (Resolve, Reject) => {
    try {
      const pageContext = store.getState().pageContext;
      const data = await getOrgBootstrapApi(orgId);
      let orgObj = {
        selectedOrg: data,
        selectedStoreTag: null,
        selectedStore: null,
        orgTreeMap: null,
      };

      orgObj = await expandSiteAndTag(orgObj);
      orgObj = await initOrgTreeMap(orgObj);
      const resultObj = Object.assign({}, pageContext, orgObj);
      store.dispatch(pageContextActions.setAll(resultObj));

      Resolve();
    } catch (error) {
      console.error(`getOrgBootstrap: ${error}`);
      Reject();
    }

  });
};

export const loadGoogleMap = () => {
  return new Promise(async (Resolve, reject) => {
    console.debug('Load Google Map API...')
    const apiKey = 'AIzaSyA17tOSStDZTFcGN_K0IsZHwYfA0YW9QtQ'
    const script = document.createElement('script');
    script.src = `https://maps.googleapis.com/maps/api/js?key=${apiKey}&callback=initMap`
    document.body.appendChild(script);

    window.initMap = () => {
      console.debug('Load Google Map API...done')
      Resolve();
    }
  })
}